enum ReviewEnum {
    GOOD = 'GOOD',
    OK = 'OK',
    BAD = 'BAD',
    NONE = 'NONE',
}
interface ProcessStats {
    totalNumberOfSteps: {
        length: number,
        review: ReviewEnum,
    };
    longestHint: {
        length: number,
        index: number,
        review: ReviewEnum,
    };
    longestMilestone: {
        length: number,
        index: number,
        review: ReviewEnum,
    };
    longestMilestoneTitle: {
        length: number,
        index: number,
        review: ReviewEnum,
    };
    missingHints: {
        hints: number[],
        review: ReviewEnum,
    };
}

interface Filter {
    search: string;
    category: string;
    requiredWords?: string[] | null;
}

export {
    ReviewEnum,
    ProcessStats,
    Filter,
};
